import types from "./types";

export default (
  state = {
    isFetchingPlanList: false,
    planList: [],
    planListError: "",

    isFetchingOrganizations: false,
    organizations: [],
    orgListError: "",

    isFetchingPrograms: false,
    programs: [],
    programListError: "",

    isFetchingPlanCard: false,
    planCard: null,
    planCardError: "",

    isFetchingPlan: false,
    planSystem: null,
    planSystemError: "",

    isFetchingPlanMain: false,
    planMain: null,
    planMainError: "",

    isCreatingPlan: false,
    createdPlan: null,
    planCreationError: "",

    isUpdatingPlan: false,
    updatedPlan: null,
    planUpdatingError: "",

    isFetchingPlanGroupList: false,
    planGroupList: [],
    planGroupListError: "",

    isCreatingGroup: false,
    createdGroup: null,
    groupCreationError: "",

    isUpdatingGroup: false,
    updatedGroup: null,
    groupUpdatingError: "",

    isRemovingGroup: false,
    removedGroup: null,
    groupRemovingError: "",

    isFetchingPlanWaitingList: false,
    planWaitingList: [],
	planWaitingListError: "",

	isFetchingSetGroup: false,
    setGroup: [],
	setGroupError: "",

    isChangingPlanStatus: false,
    changedPlanStatus: null,
    changingPlanStatusError: "",
  }, action
) => {
  switch (action.type) {
    case types.GET_PLAN_LIST_REQUEST:
      return {
        ...state,
        isFetchingPlanList: action.isFetchingPlanList
      };
    case types.GET_PLAN_LIST_COMPLETED:
      return {
        ...state,
        isFetchingPlanList: action.isFetchingPlanList,
        planList: action.planList
      };
    case types.GET_PLAN_LIST_ERROR:
      return {
        ...state,
        isFetchingPlanList: action.isFetchingPlanList,
        planListError: action.planListError
      };

  case types.GET_ORG_LIST_REQUEST:
    return {
      ...state,
      isFetchingOrganizations: action.isFetchingOrganizations
    };
  case types.GET_ORG_LIST_COMPLETED:
    return {
      ...state,
      isFetchingOrganizations: action.isFetchingOrganizations,
      organizations: action.organizations
    };
  case types.GET_ORG_LIST_ERROR:
    return {
      ...state,
      isFetchingOrganizations: action.isFetchingOrganizations,
      orgListError: action.orgListError
    };

    case types.GET_PROGRAM_LIST_REQUEST:
      return {
        ...state,
        isFetchingPrograms: action.isFetchingPrograms
      };
    case types.GET_PROGRAM_LIST_COMPLETED:
      return {
        ...state,
        isFetchingPrograms: action.isFetchingPrograms,
        programs: action.programs
      };
    case types.GET_PROGRAM_LIST_ERROR:
      return {
        ...state,
        isFetchingPrograms: action.isFetchingPrograms,
        programListError: action.programListError
      };

    case types.GET_PLAN_CARD_REQUEST:
      return {
        ...state,
        isFetchingPlanCard: action.isFetchingPlanCard
      };
    case types.GET_PLAN_CARD_COMPLETED:
      return {
        ...state,
        isFetchingPlanCard: action.isFetchingPlanCard,
        planCard: action.planCard
      };
    case types.GET_PLAN_CARD_ERROR:
      return {
        ...state,
        isFetchingPlanCard: action.isFetchingPlanCard,
        planCardError: action.planCardError
      };

    case types.GET_PLAN_SYSTEM_REQUEST:
      return {
        ...state,
        isFetchingPlan: action.isFetchingPlan,
        planMain: action.planMain
      };
    case types.GET_PLAN_SYSTEM_COMPLETED:
      return {
        ...state,
        isFetchingPlan: action.isFetchingPlan,
        planSystem: action.planSystem
      };
    case types.GET_PLAN_SYSTEM_ERROR:
      return {
        ...state,
        isFetchingPlan: action.isFetchingPlan,
        planSystemError: action.planSystemError
      };

    case types.GET_PLAN_MAIN_REQUEST:
      return {
        ...state,
        isFetchingPlanMain: action.isFetchingPlanMain
      };
    case types.GET_PLAN_MAIN_COMPLETED:
      return {
        ...state,
        isFetchingPlanMain: action.isFetchingPlanMain,
        planMain: action.planMain
      };
    case types.GET_PLAN_MAIN_ERROR:
      return {
        ...state,
        isFetchingPlanMain: action.isFetchingPlanMain,
        planMainError: action.planMainError
      };

    case types.CREATE_PLAN_REQUEST:
      return {
        ...state,
        isCreatingPlan: action.isCreatingPlan
      };
    case types.CREATE_PLAN_COMPLETED:
      return {
        ...state,
        isCreatingPlan: action.isCreatingPlan,
        createdPlan: action.createdPlan
      };
    case types.CREATE_PLAN_ERROR:
      return {
        ...state,
        isCreatingPlan: action.isCreatingPlan,
        planCreationError: action.planCreationError
      };

    case types.UPDATE_PLAN_REQUEST:
      return {
        ...state,
        isUpdatingPlan: action.isUpdatingPlan
      };
    case types.UPDATE_PLAN_COMPLETED:
      return {
        ...state,
        isUpdatingPlan: action.isUpdatingPlan,
        updatedPlan: action.updatedPlan
      };
    case types.UPDATE_PLAN_ERROR:
      return {
        ...state,
        isUpdatingPlan: action.isUpdatingPlan,
        planUpdatingError: action.planUpdatingError
      };

      case types.GET_PLAN_GROUP_LIST_REQUEST:
        return {
          ...state,
          isFetchingPlanGroupList: action.isFetchingPlanGroupList
        };
      case types.GET_PLAN_GROUP_LIST_COMPLETED:
        return {
          ...state,
          isFetchingPlanGroupList: action.isFetchingPlanGroupList,
          planGroupList: action.planGroupList
        };
      case types.GET_PLAN_GROUP_LIST_ERROR:
        return {
          ...state,
          isFetchingPlanGroupList: action.isFetchingPlanGroupList,
          planGroupListError: action.planGroupListError
        };

      case types.CREATE_GROUP_REQUEST:
        return {
          ...state,
          isCreatingGroup: action.isCreatingGroup
        };
      case types.CREATE_GROUP_COMPLETED:
        return {
          ...state,
          isCreatingGroup: action.isCreatingGroup,
          createdGroup: action.createdGroup
        };
      case types.CREATE_GROUP_ERROR:
        return {
          ...state,
          isCreatingGroup: action.isCreatingGroup,
          groupCreationError: action.groupCreationError
        };

    case types.UPDATE_GROUP_REQUEST:
      return {
        ...state,
        isUpdatingGroup: action.isUpdatingGroup
      };
    case types.UPDATE_GROUP_COMPLETED:
      return {
        ...state,
        isUpdatingGroup: action.isUpdatingGroup,
        updatedGroup: action.updatedGroup
      };
    case types.UPDATE_GROUP_ERROR:
      return {
        ...state,
        isUpdatingGroup: action.isUpdatingGroup,
        groupUpdatingError: action.groupUpdatingError
      };

    case types.REMOVE_GROUP_REQUEST:
      return {
        ...state,
        isRemovingGroup: action.isRemovingGroup
      };
    case types.REMOVE_GROUP_COMPLETED:
      return {
        ...state,
        isRemovingGroup: action.isRemovingGroup,
        removedGroup: action.removedGroup
      };
    case types.REMOVE_GROUP_ERROR:
      return {
        ...state,
        isRemovingGroup: action.isRemovingGroup,
        groupRemovingError: action.groupRemovingError
      };

    case types.GET_PLAN_WAITING_LIST_REQUEST:
      return {
        ...state,
        isFetchingPlanWaitingList: action.isFetchingPlanWaitingList
      };
    case types.GET_PLAN_WAITING_LIST_COMPLETED:
      return {
        ...state,
        isFetchingPlanWaitingList: action.isFetchingPlanWaitingList,
        planWaitingList: action.planWaitingList
      };
    case types.GET_PLAN_WAITING_LIST_ERROR:
      return {
        ...state,
        isFetchingPlanWaitingList: action.isFetchingPlanWaitingList,
        planWaitingListError: action.planWaitingListError
	  };

	  case types.SET_GROUP_REQUEST:
		return {
		  ...state,
		  isFetchingSetGroup: action.isFetchingSetGroup
		};
	  case types.SET_GROUP_COMPLETED:
		return {
		  ...state,
		  isFetchingSetGroup: action.isFetchingSetGroup,
		  setGroup: action.setGroup
		};
	  case types.SET_GROUP_ERROR:
		return {
		  ...state,
		  isFetchingSetGroup: action.isFetchingSetGroup,
		  setGroupError: action.setGroupError
		};

    case types.CHANGE_STATE_PLAN_REQUEST:
      return {
        ...state,
        isChangingPlanStatus: action.isChangingPlanStatus
      };
    case types.CHANGE_STATE_PLAN_COMPLETED:
      return {
        ...state,
        isChangingPlanStatus: action.isChangingPlanStatus,
        changedPlanStatus: action.changedPlanStatus
      };
    case types.CHANGE_STATE_PLAN_ERROR:
      return {
        ...state,
        isChangingPlanStatus: action.isChangingPlanStatus,
        changingPlanStatusError: action.changingPlanStatusError
      };

      default:
        return state;
  }
};
